export default __webpack_public_path__ + "static/media/LilNounsReadingNounpunks.2967fcbd.png";